export default "__VITE_ASSET__BoTofK$Z__"